// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"edfa5dad","209":"ba4a43f2","220":"6d518744","475":"c48cb3dd","596":"ae075251","641":"c2b9f961","830":"1af51b61","981":"3ffda9fb"}[chunkId] + ".chunk.js";
};